import { useFetch } from "./Fetching";
import useUser from "./useUser";

export function useGetClinicUsers() {
  const { currentClinic } = useUser();
  const { data, isLoading, error } = useFetch(
    `/clinic/users/${currentClinic.id}`,
    null,
    "clinic_users"
  );
  return { data, isLoading, error };
}
